import { useEffect, useCallback } from 'react'
import { useAuth } from '@/contexts/AuthContext'

type ColorScheme = 'argalis' | 'neutral'

export function useColorScheme() {
    const { user, updatePreferences } = useAuth()
    // Use localStorage as fallback while user data loads (prevents anti-FOUC class removal)
    const colorScheme: ColorScheme = user?.preferences?.global?.color_scheme
        ?? (localStorage.getItem('argalis-color-scheme') as ColorScheme | null)
        ?? 'argalis'

    useEffect(() => {
        document.documentElement.classList.toggle('neutral', colorScheme === 'neutral')
        localStorage.setItem('argalis-color-scheme', colorScheme)
    }, [colorScheme])

    const setColorScheme = useCallback(
        (newScheme: ColorScheme) => {
            updatePreferences({ global: { color_scheme: newScheme } })
        },
        [updatePreferences],
    )

    return { colorScheme, setColorScheme }
}
